import { MappingProblemStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const mappingProblemStatusDictionary = createSimpleDictionary([
    { id: MappingProblemStatus.Open, name: 'dictionaries.mappingProblemStatus.open' },
    { id: MappingProblemStatus.Processing, name: 'dictionaries.mappingProblemStatus.processing' },
    { id: MappingProblemStatus.ResolvedManual, name: 'dictionaries.mappingProblemStatus.resolvedManual' },
    { id: MappingProblemStatus.ResolvedThirdParty, name: 'dictionaries.mappingProblemStatus.resolvedThirdParty' },
    { id: MappingProblemStatus.ResolvedAutomatic, name: 'dictionaries.mappingProblemStatus.resolvedAutomatic' },
    { id: MappingProblemStatus.AwaitingData, name: 'dictionaries.mappingProblemStatus.awaitingData' },
]);
